<template lang="pug">
v-container(fluid)
  .d-flex.flex-column(style="gap: 16px;")
    v-card
      v-card-title
        span.mr-2 {{currentBusiness.name}}
        BusinessFormModal
      v-card-text
        div.mb-2
          strong.mr-2 Nombre de la empresa:
          span {{currentBusiness.name}}
        div.mb-2
          strong.mr-2 Dueño:
          span {{currentBusiness.owner_full_name}}
        div.mb-2
          strong.mr-2 Giro:
          span {{currentBusiness.line_of_business_display}}

    v-card
      v-card-title Modo de catálogo
      v-card-subtitle Define cómo modelas lo que vendes. Puedes cambiarlo cuando quieras.
      v-card-text
        v-radio-group(v-model="catalogMode" :disabled="savingMode" hide-details)
          v-radio(value="simplificado")
            template(v-slot:label)
              div
                .font-weight-medium Simplificado
                .caption.grey--text Líneas de negocio con productos o servicios concretos y su ticket promedio.
          v-radio.mt-3(value="detallado")
            template(v-slot:label)
              div
                .font-weight-medium Detallado
                .caption.grey--text Familias con variantes y atributos (color, gramaje, volumen) que generan SKU.
        v-btn.mt-4(
          color="primary"
          depressed
          :loading="savingMode"
          :disabled="catalogMode === (currentBusiness && currentBusiness.catalog_mode)"
          @click="saveMode"
        ) Guardar modo

    v-card
      v-card-title
        span Lista de Usuarios
        v-spacer 
        BusinessInvitationFormModal
      v-simple-table(key="list-users")
        template(v-slot:default)
          thead(key="list-users-header")
            tr
              th Nombre
              th Correo
              th Rol
              th Activo
          tbody(key="list-users-body")
            tr(v-for="member in members" :key="member.id")
              td {{member.member.full_name}}
              td {{member.member.email}}
              td {{member.role | userRole}}
              td
                v-icon(v-if="member.is_active" color="green") mdi-checkbox-marked
                v-icon(v-else="member.is_active" color="red") mdi-close-box
</template>

<script>
import BusinessFormModal from '@/components/business_config/BusinessFormModal.vue'
import BusinessInvitationFormModal from '@/components/business_config/BusinessInvitationFormModal.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    BusinessFormModal,
    BusinessInvitationFormModal,
  },
  data () {
    return {
      members: [

      ],
      catalogMode: 'detallado',
      savingMode: false,
    }
  },
  computed: {
    ...mapGetters('app_config', ['currentBusiness'])
  },
  methods: {
    ...mapActions('business', ['listBusinessMembers', 'updateCatalogMode']),
    async saveMode () {
      this.savingMode = true
      const res = await this.updateCatalogMode(this.catalogMode)
      this.savingMode = false
      if (res && res.status >= 200 && res.status < 300) {
        this.$toast.success('Modo de catálogo actualizado.')
      } else {
        this.$toast.error('No se pudo actualizar el modo.')
      }
    }
  },
  watch: {
    currentBusiness: {
      immediate: true,
      handler (b) {
        if (b && b.catalog_mode) this.catalogMode = b.catalog_mode
      }
    }
  },
  async created () {
    const response = await this.listBusinessMembers()
    this.members = response.data.results
  }
}
</script>